import { Toaster, ToastBar, toast } from 'react-hot-toast';
import { X, Check, AlertCircle, Info } from 'lucide-react';

export const MyToaster = () => {
    return (
        <Toaster
            position="bottom-right"
            toastOptions={{
                duration: 4000,
                style: {
                    background: 'rgba(15, 23, 42, 0.8)',
                    backdropFilter: 'blur(12px)',
                    border: '1px solid rgba(255, 255, 255, 0.1)',
                    color: '#fff',
                    padding: '16px',
                    borderRadius: '16px',
                    boxShadow: '0 25px 50px -12px rgba(0, 0, 0, 0.5)',
                },
            }}
        >
            {(t) => (
                <ToastBar toast={t}>
                    {({ message }) => (
                        <div className={`flex items-start gap-3 w-full max-w-sm`}>
                            {t.type === 'success' && <div className="p-2 bg-green-500/20 rounded-full text-green-400"><Check size={18} /></div>}
                            {t.type === 'error' && <div className="p-2 bg-red-500/20 rounded-full text-red-400"><AlertCircle size={18} /></div>}
                            {t.type === 'loading' && <div className="p-2 bg-blue-500/20 rounded-full text-blue-400 animate-spin"><div className="w-4 h-4 border-2 border-current border-t-transparent rounded-full" /></div>}
                            {t.type === 'blank' && <div className="p-2 bg-gray-500/20 rounded-full text-gray-400"><Info size={18} /></div>}

                            <div className="flex-1 pt-1 text-sm font-medium">
                                {message}
                            </div>

                            <button
                                onClick={() => toast.dismiss(t.id)}
                                className="p-1 hover:bg-white/10 rounded-full text-gray-500 hover:text-white transition-colors"
                            >
                                <X size={14} />
                            </button>
                        </div>
                    )}
                </ToastBar>
            )}
        </Toaster>
    );
};
